import { ModuleQuestion } from "../types/ProgramModel";
import api from "./api";

export const getPrograms = async () => {
  try {
    const response = await api.get("/programs");
    return response.data;
  } catch (error) {
    console.error("Failed to fetch programs", error);
    throw error;
  }
};

// Updated to include programId as an argument
export const getProgramWeek = async (weekId: string) => {
  try {
    const response = await api.get(`/programs/weeks/${weekId}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch program week", error);
    throw error;
  }
};

export const getProgramModule = async (moduleId: string) => {
  try {
    const response = await api.get(`/programs/module/${moduleId}`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch program module", error);
    throw error;
  }
};

export const getQuestions = async (moduleId: string) => {
  try {
    const response = await api.get(`/programs/module/${moduleId}/questions`);
    return response.data;
  } catch (error) {
    console.error("Failed to fetch questions", error);
    throw error;
  }
};

// export const createQuestion = async (questionData: ModuleQuestion) => {
//   try {
//     const response = await api.post(
//       `/programs/modules/${questionData.moduleId}/questions`,
//       questionData,
//       {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       }
//     );

//     return response.data;
//   } catch (error) {
//     console.error("Error creating question:", error);

//     throw error;
//   }
// };

export const updateQuestion = async (
  moduleId: string,
  questionId: string,
  updatedData: ModuleQuestion
) => {
  try {
    const response = await api.put(
      `/programs/module/${moduleId}/questions/${questionId}`,
      updatedData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating question:", error);
    throw error;
  }
};

export const deleteQuestion = async (questionId: string) => {
  try {
    const response = await api.delete(`/programs/module/questions/${questionId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting question:", error);
    throw error;
  }
};

export const submitAnswer = async (
  moduleId: string,
  questionId: string,
  formData: FormData
) => {
  try {
    const response = await api.post(
      `/programs/module/${moduleId}/questions/${questionId}/answer`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error submitting answer:", error);
    throw error;
  }
};

/**
 * Submit a speaking practice answer with audio and target text
 *
 * This is the updated function that sends the target script along with the audio
 * so Gemini can compare what the student said vs what they should have said.
 *
 * @param moduleId - The module ID
 * @param questionId - The question ID
 * @param audioBlob - The recorded audio blob
 * @param targetText - The sentence the student was supposed to say
 * @returns Promise with transcription and feedback
 */
export const submitSpeakingAnswer = async (
  moduleId: string,
  questionId: string,
  audioBlob: Blob,
  targetText: string
) => {
  try {
    const formData = new FormData();
    formData.append("file", audioBlob, "audio.webm");
    formData.append("targetText", targetText); // CRITICAL: Send the target text!

    const response = await api.post(
      `/speaking/analyse-pronunciation`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error submitting speaking answer:", error);
    throw error;
  }
};
